var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSubscribed && !_vm.denied)?_c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":_vm.localSubscribe}},[_vm._v("\n  Subscribe to Push Notifications\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }